import { useT } from "../lib/i18n";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

export default function Privacy() {
  const { t } = useT();
  return (
    <div className="min-h-screen bg-[#F8F5F2] text-[#1A1A1A]">
      <div className="max-w-3xl mx-auto px-4 md:px-8 py-16">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-ink2 hover:text-[#6E1A24] mb-8">
          <ArrowLeft className="w-4 h-4" /> ← Back
        </Link>
        <h1 className="heading-poster text-4xl md:text-5xl mb-8">Privacy Policy / Polityka prywatności</h1>
        <div className="prose prose-lg max-w-none space-y-6 text-ink2">
          <h2>English</h2>
          <p><strong>Data Controller:</strong> Connect & Elevate Network, Warsaw, Poland.</p>
          <p><strong>Data collected:</strong> Full name, phone number, email, Telegram username — collected during registration for the purpose of event organization and communication.</p>
          <p><strong>Payment data:</strong> Processed securely by Stripe. We do not store card details.</p>
          <p><strong>Cookies:</strong> We use essential cookies for site functionality and analytics cookies to improve user experience. You can manage cookie preferences via the cookie banner.</p>
          <p><strong>Data retention:</strong> Personal data is retained for 12 months after the event, then deleted.</p>
          <p><strong>Your rights:</strong> You have the right to access, correct, or delete your data. Contact us via the contact form or Telegram at <a href="https://t.me/yepgt" className="text-[#6E1A24]">@yepgt</a>.</p>

          <hr className="border-[#E2D8CF]" />

          <h2>Polski</h2>
          <p><strong>Administrator danych:</strong> Connect & Elevate Network, Warszawa, Polska.</p>
          <p><strong>Zbierane dane:</strong> Imię i nazwisko, numer telefonu, email, nazwa użytkownika Telegram — zbierane podczas rejestracji w celu organizacji wydarzenia i komunikacji.</p>
          <p><strong>Dane płatnicze:</strong> Przetwarzane bezpiecznie przez Stripe. Nie przechowujemy danych kart.</p>
          <p><strong>Cookies:</strong> Używamy niezbędnych plików cookies do funkcjonowania strony oraz cookies analitycznych do poprawy doświadczenia użytkownika. Preferencje cookies możesz zarządzać przez baner cookies.</p>
          <p><strong>Okres przechowywania:</strong> Dane osobowe są przechowywane przez 12 miesięcy po wydarzeniu, a następnie usuwane.</p>
          <p><strong>Twoje prawa:</strong> Masz prawo do dostępu, poprawienia lub usunięcia swoich danych. Skontaktuj się z nami przez formularz kontaktowy lub Telegram: <a href="https://t.me/yepgt" className="text-[#6E1A24]">@yepgt</a>.</p>
        </div>
      </div>
    </div>
  );
}
